export const Cities = {
  shanghai: 'onboarding.page3.location.shanghai',
  beijing: 'onboarding.page3.location.beijing',
  guangzhou: 'onboarding.page3.location.guangzhou',
  hangzhou: 'onboarding.page3.location.hangzhou',
  shenzhen: 'onboarding.page3.location.shenzhen',
  silicon: 'onboarding.page3.location.silicon',
  bangalore: 'onboarding.page3.location.bangalore',
  london: 'onboarding.page3.location.london',
  tokyo: 'onboarding.page3.location.tokyo',
  newYork: 'onboarding.page3.location.newYork',
}

export const Address = {
  shanghai: {
    SongHuRoad333: '淞沪路 333 号',
    SongHuRoad303: '淞沪路 303 号',
    WeiChengRoad: '伟成路 62 号',
  },
  beijing: {
    GuangShunSouthStreet: '广顺南大街 16 号',
  },
  shenzhen: {
    XunMeiPlaza: '讯美科技广场 3 号楼',
  },
  hangzhou: {
    LvGu: '绿谷海创绿谷 5 栋',
    AcademicRoad: '黄龙万科中心 B 座',
  },
  guangzhou: {
    LvDiCenter: '金融城绿地中心',
  },
  silicon: {
    default: 'N/A',
  },
  bangalore: {
    default: 'N/A',
  },
  london: {
    default: 'N/A',
  },
  tokyo: {
    default: 'N/A',
  },
  newYork: {
    default: 'N/A',
  },
}

export const Floors = {
  SongHuRoad333: {
    6: '6 F',
    7: '7 F',
    8: '8 F',
    9: '9 F',
  },
  SongHuRoad303: {
    8: '8 F',
    9: '9 F',
    10: '10 F',
  },
  WeiChengRoad: {
    5: '5 F',
  },
  GuangShunSouthStreet: {
    30: '30 F',
    20: '20 F',
  },
  XunMeiPlaza: {
    14: '14B10',
  },
  LvGu: {
    2: '205',
  },
  LvDiCenter: {
    7: '712',
    8: '1805',
  },
  AcademicRoad: {
    6: '6 F',
  },
  default: {
    default: 'N/A',
  },
}
